/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Enum for admin job request sort
 */
export enum AllowedAdminJobRequestSort {
  COUNTRY_ASC = "COUNTRY_ASC",
  COUNTRY_DESC = "COUNTRY_DESC",
  EARLIEST_DELIVERY_DATE_ASC = "EARLIEST_DELIVERY_DATE_ASC",
  EARLIEST_DELIVERY_DATE_DESC = "EARLIEST_DELIVERY_DATE_DESC",
  EARLIEST_RECEIPT_DATE_ASC = "EARLIEST_RECEIPT_DATE_ASC",
  EARLIEST_RECEIPT_DATE_DESC = "EARLIEST_RECEIPT_DATE_DESC",
  MP_NAME_ASC = "MP_NAME_ASC",
  MP_NAME_DESC = "MP_NAME_DESC",
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
  PRIORITY_ASC = "PRIORITY_ASC",
  PRIORITY_DESC = "PRIORITY_DESC",
  PROJECT_NAME_ASC = "PROJECT_NAME_ASC",
  PROJECT_NAME_DESC = "PROJECT_NAME_DESC",
  REQUEST_DATE_ASC = "REQUEST_DATE_ASC",
  REQUEST_DATE_DESC = "REQUEST_DATE_DESC",
  SALE_ORDER_NAME_ASC = "SALE_ORDER_NAME_ASC",
  SALE_ORDER_NAME_DESC = "SALE_ORDER_NAME_DESC",
  STATE_ASC = "STATE_ASC",
  STATE_DESC = "STATE_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
  VENDOR_DUE_DATE_ASC = "VENDOR_DUE_DATE_ASC",
  VENDOR_DUE_DATE_DESC = "VENDOR_DUE_DATE_DESC",
}

/**
 * Allowed attachment from sources
 */
export enum AllowedAttachmentSources {
  MP = "MP",
  QC = "QC",
}

/**
 * Enum for the allowed sort on Exceptions
 */
export enum AllowedExceptionsSort {
  ACTION_ASC = "ACTION_ASC",
  ACTION_DESC = "ACTION_DESC",
  ASSIGNEE_ASC = "ASSIGNEE_ASC",
  ASSIGNEE_DESC = "ASSIGNEE_DESC",
  CAR_NAME_ASC = "CAR_NAME_ASC",
  CAR_NAME_DESC = "CAR_NAME_DESC",
  CAR_STATUS_ASC = "CAR_STATUS_ASC",
  CAR_STATUS_DESC = "CAR_STATUS_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  EARLIEST_DELIVERY_DATE_ASC = "EARLIEST_DELIVERY_DATE_ASC",
  EARLIEST_DELIVERY_DATE_DESC = "EARLIEST_DELIVERY_DATE_DESC",
  EARLIEST_RECEIPT_DATE_ASC = "EARLIEST_RECEIPT_DATE_ASC",
  EARLIEST_RECEIPT_DATE_DESC = "EARLIEST_RECEIPT_DATE_DESC",
  EARLIEST_SHIP_DATE_ASC = "EARLIEST_SHIP_DATE_ASC",
  EARLIEST_SHIP_DATE_DESC = "EARLIEST_SHIP_DATE_DESC",
  MP_CAR_TURNAROUND_DAYS_ASC = "MP_CAR_TURNAROUND_DAYS_ASC",
  MP_CAR_TURNAROUND_DAYS_DESC = "MP_CAR_TURNAROUND_DAYS_DESC",
  MP_NAME_ASC = "MP_NAME_ASC",
  MP_NAME_DESC = "MP_NAME_DESC",
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
  SALE_ORDER_NAME_ASC = "SALE_ORDER_NAME_ASC",
  SALE_ORDER_NAME_DESC = "SALE_ORDER_NAME_DESC",
  STATUS_ASC = "STATUS_ASC",
  STATUS_DESC = "STATUS_DESC",
  TYPE_ASC = "TYPE_ASC",
  TYPE_DESC = "TYPE_DESC",
  UPDATED_AT_ASC = "UPDATED_AT_ASC",
  UPDATED_AT_DESC = "UPDATED_AT_DESC",
  WORK_ORDER_NAME_ASC = "WORK_ORDER_NAME_ASC",
  WORK_ORDER_NAME_DESC = "WORK_ORDER_NAME_DESC",
  WORK_ORDER_REQUEST_DATE_ASC = "WORK_ORDER_REQUEST_DATE_ASC",
  WORK_ORDER_REQUEST_DATE_DESC = "WORK_ORDER_REQUEST_DATE_DESC",
}

/**
 * Allowed types for Work Order inspection documents
 */
export enum AllowedInspectionDocumentType {
  additionalDoc = "additionalDoc",
  advancedInspection = "advancedInspection",
  certificateOfConformance = "certificateOfConformance",
  fictiv5 = "fictiv5",
  manufacturingDrawing = "manufacturingDrawing",
  materialCertification = "materialCertification",
  partPhoto = "partPhoto",
  unknown = "unknown",
}

/**
 * Allowed types for inspectionTypes
 */
export enum AllowedInspectionType {
  dimensional = "dimensional",
  general = "general",
  not_applicable = "not_applicable",
  visual = "visual",
}

/**
 * Allowed MfgPartner Sort Type
 */
export enum AllowedMfgPartnerLevelsSort {
  ACCEPTANCE_RATIO_ASC = "ACCEPTANCE_RATIO_ASC",
  ACCEPTANCE_RATIO_DESC = "ACCEPTANCE_RATIO_DESC",
  CAR_TURNAROUND_DAYS_ASC = "CAR_TURNAROUND_DAYS_ASC",
  CAR_TURNAROUND_DAYS_DESC = "CAR_TURNAROUND_DAYS_DESC",
  EXPIRATION_RATIO_ASC = "EXPIRATION_RATIO_ASC",
  EXPIRATION_RATIO_DESC = "EXPIRATION_RATIO_DESC",
  IF_RATIO_ASC = "IF_RATIO_ASC",
  IF_RATIO_DESC = "IF_RATIO_DESC",
  OT_RATIO_ASC = "OT_RATIO_ASC",
  OT_RATIO_DESC = "OT_RATIO_DESC",
}

/**
 * Allowed Quality document types
 */
export enum AllowedQualityAttachmentTypes {
  ADDITIONAL_DOCS = "ADDITIONAL_DOCS",
  ADVANCED_INSPECTION = "ADVANCED_INSPECTION",
  CERTIFICATE_OF_CONFORMANCE = "CERTIFICATE_OF_CONFORMANCE",
  FICTIV5 = "FICTIV5",
  MATERIAL_CERTIFICATION = "MATERIAL_CERTIFICATION",
  PHOTOS = "PHOTOS",
}

/**
 * Enum for the allowed sort on SalesOrders
 */
export enum AllowedSalesOrderSort {
  CAR_COUNT_ASC = "CAR_COUNT_ASC",
  CAR_COUNT_DESC = "CAR_COUNT_DESC",
  COMMITTED_DELIVERY_DATE_ASC = "COMMITTED_DELIVERY_DATE_ASC",
  COMMITTED_DELIVERY_DATE_DESC = "COMMITTED_DELIVERY_DATE_DESC",
  EARLIEST_DELIVERY_DATE_ASC = "EARLIEST_DELIVERY_DATE_ASC",
  EARLIEST_DELIVERY_DATE_DESC = "EARLIEST_DELIVERY_DATE_DESC",
  EARLIEST_SHIP_DATE_ASC = "EARLIEST_SHIP_DATE_ASC",
  EARLIEST_SHIP_DATE_DESC = "EARLIEST_SHIP_DATE_DESC",
  EXCEPTION_COUNT_ASC = "EXCEPTION_COUNT_ASC",
  EXCEPTION_COUNT_DESC = "EXCEPTION_COUNT_DESC",
  JOB_COUNT_ASC = "JOB_COUNT_ASC",
  JOB_COUNT_DESC = "JOB_COUNT_DESC",
  NAME_ASC = "NAME_ASC",
  NAME_DESC = "NAME_DESC",
  ORDER_DATE_ASC = "ORDER_DATE_ASC",
  ORDER_DATE_DESC = "ORDER_DATE_DESC",
  PRIORITY_ASC = "PRIORITY_ASC",
  PRIORITY_DESC = "PRIORITY_DESC",
  PROJECT_NAME_ASC = "PROJECT_NAME_ASC",
  PROJECT_NAME_DESC = "PROJECT_NAME_DESC",
  REGION_ASC = "REGION_ASC",
  REGION_DESC = "REGION_DESC",
  WORK_ORDER_COUNT_ASC = "WORK_ORDER_COUNT_ASC",
  WORK_ORDER_COUNT_DESC = "WORK_ORDER_COUNT_DESC",
}

/**
 * Allowed Subject Types
 */
export enum AllowedSubjectTypes {
  ADDITIONAL_PHOTOS_NEEDED = "ADDITIONAL_PHOTOS_NEEDED",
  CAPACITY = "CAPACITY",
  DUE_DATE = "DUE_DATE",
  JOB_DELAY = "JOB_DELAY",
  MATERIAL_SOURCING = "MATERIAL_SOURCING",
  MISSING_FICTIV5_REPORT = "MISSING_FICTIV5_REPORT",
  MISSING_PART_PHOTOS = "MISSING_PART_PHOTOS",
  MISSING_REQUIRED_ADDITIONAL_DOCUMENT = "MISSING_REQUIRED_ADDITIONAL_DOCUMENT",
  NEED_CLARIFICATION = "NEED_CLARIFICATION",
  OTHER = "OTHER",
  OUT_OF_SPEC = "OUT_OF_SPEC",
  PRICING = "PRICING",
  PROBLEM_IN_PRODUCTION = "PROBLEM_IN_PRODUCTION",
  VERIFY_AN_INSPECTION_POINT = "VERIFY_AN_INSPECTION_POINT",
  WORKFLOW = "WORKFLOW",
}

/**
 * Enum for allowed Attachment type in AttachmentInput
 */
export enum AttachmentCreateType {
  annotated = "annotated",
  auto_generated = "auto_generated",
  user_auto_generated = "user_auto_generated",
  user_uploaded = "user_uploaded",
}

/**
 * Enum of all BusinessAccountContactStatus
 */
export enum BusinessAccountContactStatus {
  invitation_expired = "invitation_expired",
  member = "member",
  not_invited = "not_invited",
  pending_email_verification = "pending_email_verification",
  requested = "requested",
}

/**
 * Types of Business Account Features
 */
export enum BusinessAccountFeatureInput {
  clt_optimizer = "clt_optimizer",
  consultative_dfm = "consultative_dfm",
  po_enabled = "po_enabled",
  tax_exempt = "tax_exempt",
  teams = "teams",
}

/**
 * The status of the business account
 */
export enum BusinessAccountInviteStatus {
  accepted = "accepted",
  expired = "expired",
  not_requested = "not_requested",
  pending_account_creation = "pending_account_creation",
  pending_email_verification = "pending_email_verification",
  requested = "requested",
}

/**
 * Enum for membership status filter input
 */
export enum BusinessAccountMembershipFilterType {
  invited = "invited",
  member = "member",
  non_member = "non_member",
  not_invited = "not_invited",
}

/**
 * Status of business account membership used for filtering
 */
export enum BusinessAccountMembershipStatus {
  active = "active",
  deactivated = "deactivated",
}

/**
 * Enum for possible corrective action request cancellation reasons
 */
export enum CancellationReasonType {
  de_escalate_failure = "de_escalate_failure",
  failure_caused_by_carrier = "failure_caused_by_carrier",
  fault_misassigned = "fault_misassigned",
  legacy_car = "legacy_car",
  no_response = "no_response",
  other_manufacturing_partner = "other_manufacturing_partner",
  responsibility_unclear = "responsibility_unclear",
}

/**
 * Enum for possible corrective action request attachment sources
 */
export enum CorrectiveActionRequestAttachmentSourceType {
  FICTIV = "FICTIV",
  MP = "MP",
}

/**
 * Enum for allowed corrective action request failure types
 */
export enum CorrectiveActionRequestFailureType {
  FICTIV_IF = "FICTIV_IF",
  FICTIV_OT = "FICTIV_OT",
  MP_IF = "MP_IF",
  MP_OT = "MP_OT",
}

/**
 * Enum for allowed corrective action request question types
 */
export enum CorrectiveActionRequestQuestionType {
  containment_action = "containment_action",
  corrective_action = "corrective_action",
  extent_of_condition_and_cause = "extent_of_condition_and_cause",
  preventive_action = "preventive_action",
  root_cause_how_caused = "root_cause_how_caused",
  root_cause_how_escaped = "root_cause_how_escaped",
}

/**
 * Enum for allowed corrective action request sort options
 */
export enum CorrectiveActionRequestSortInput {
  CANCELED_AT_ASC = "CANCELED_AT_ASC",
  CANCELED_AT_DESC = "CANCELED_AT_DESC",
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
  DUE_AT_ASC = "DUE_AT_ASC",
  DUE_AT_DESC = "DUE_AT_DESC",
  SENT_AT_ASC = "SENT_AT_ASC",
  SENT_AT_DESC = "SENT_AT_DESC",
  SENT_FOR_REWORK_AT_ASC = "SENT_FOR_REWORK_AT_ASC",
  SENT_FOR_REWORK_AT_DESC = "SENT_FOR_REWORK_AT_DESC",
  SUBMITTED_AT_ASC = "SUBMITTED_AT_ASC",
  SUBMITTED_AT_DESC = "SUBMITTED_AT_DESC",
  VIEWED_AT_ASC = "VIEWED_AT_ASC",
  VIEWED_AT_DESC = "VIEWED_AT_DESC",
}

/**
 * corrective action request statuses
 */
export enum CorrectiveActionRequestStatus {
  approved = "approved",
  canceled = "canceled",
  closed = "closed",
  in_progress = "in_progress",
  pending = "pending",
  rework = "rework",
  submitted = "submitted",
  voided = "voided",
}

/**
 * Enum for allowed corrective action request statuses types
 */
export enum CorrectiveActionRequestType {
  fictiv = "fictiv",
  mp = "mp",
}

/**
 * Type of DfmFeedbackMessage. Can be for auto-dfm or for admin manual dfm
 */
export enum DfmFeedbackMessageType {
  auto = "auto",
  manual = "manual",
}

/**
 * Level of severity for a piece of dfm feedback
 */
export enum DfmFeedbackSeverity {
  cost_driver = "cost_driver",
  failure = "failure",
  notice = "notice",
  warning = "warning",
}

/**
 * Possible values of dfmTags
 */
export enum DfmTags {
  AUTO = "AUTO",
  EDM = "EDM",
  ENGRAVING = "ENGRAVING",
  FICTIV_FIVE = "FICTIV_FIVE",
  FINISHING = "FINISHING",
  FIVE_AXIS = "FIVE_AXIS",
  FOUR_AXIS = "FOUR_AXIS",
  GUN_DRILLING = "GUN_DRILLING",
  HARDWARE_INSTALLATION = "HARDWARE_INSTALLATION",
  HOBBING = "HOBBING",
  LATHE = "LATHE",
  LEAD_TIME_RESTRICTED = "LEAD_TIME_RESTRICTED",
  LIVE_TOOLING_LATHE = "LIVE_TOOLING_LATHE",
  MILL = "MILL",
  NON_STANDARD_MATERIAL = "NON_STANDARD_MATERIAL",
  OTS_REWORK = "OTS_REWORK",
  OVERSEAS = "OVERSEAS",
  REORDER = "REORDER",
  REVISION = "REVISION",
  SHEET_METAL = "SHEET_METAL",
  SPECIAL_TOOLING = "SPECIAL_TOOLING",
  STOCK_THICKNESS_APPROVED = "STOCK_THICKNESS_APPROVED",
  THREE_D_MACHINING = "THREE_D_MACHINING",
  TIGHT_TOLERANCES = "TIGHT_TOLERANCES",
  UNDERCUTS = "UNDERCUTS",
  VENDOR_QUOTED = "VENDOR_QUOTED",
  WATERJET = "WATERJET",
}

/**
 * Current status of user's email verification
 */
export enum EmailVerificationStatus {
  not_initiated = "not_initiated",
  pending = "pending",
  verified = "verified",
}

/**
 * the zip mode for estimateItems
 */
export enum EstimateItemZipMode {
  drawings = "drawings",
  models = "models",
  models_and_drawings = "models_and_drawings",
  models_and_sanitized = "models_and_sanitized",
  sanitized_drawings = "sanitized_drawings",
}

/**
 * Enum for exception Assignee
 */
export enum ExceptionAssignee {
  fulfillment = "fulfillment",
  logistics = "logistics",
  mp = "mp",
  quality = "quality",
  tcs = "tcs",
}

/**
 * Enum for allowed exception states for CARs filter
 */
export enum ExceptionStates {
  CLOSED_EXCEPTION = "CLOSED_EXCEPTION",
  CLOSED_FAILURE = "CLOSED_FAILURE",
  OPEN_EXCEPTION = "OPEN_EXCEPTION",
  OPEN_FAILURE = "OPEN_FAILURE",
  VOIDED_EXCEPTION = "VOIDED_EXCEPTION",
}

/**
 * types of failures
 */
export enum FailureTypes {
  IF = "IF",
  OT = "OT",
}

/**
 * This defines whether the feature flag
 * will be used to pass to the UI, or for effecting the
 * backend.
 * These are seperate concerns, and for some features, you may
 * end up needing to define 2 separate ones.
 */
export enum FeatureFlagScope {
  SERVER_FLAG = "SERVER_FLAG",
  UI_FLAG = "UI_FLAG",
}

/**
 * Allowed partTypes values
 */
export enum HtsUsageType {
  production = "production",
  prototype = "prototype",
  unspecified = "unspecified",
}

/**
 * Instant quoter result storing operation status
 */
export enum InstantQuoterStatus {
  failure = "failure",
  success = "success",
}

/**
 * Options for job request inspection status
 */
export enum JobRequestInspectionStatus {
  completed = "completed",
  in_progress = "in_progress",
  pending = "pending",
}

/**
 * Job request post process risk status
 */
export enum JobRequestRiskState {
  at_risk = "at_risk",
  completed = "completed",
  not_available = "not_available",
  not_started = "not_started",
  on_track = "on_track",
}

/**
 * Options for job request status
 */
export enum JobRequestStatus {
  accepted = "accepted",
  canceled = "canceled",
  completed = "completed",
  expired = "expired",
  rejected = "rejected",
  sent = "sent",
  viewed = "viewed",
}

/**
 * ENUM for manual cancel car reasons
 */
export enum ManualCarCancelationReasons {
  failure_caused_by_carrier = "failure_caused_by_carrier",
  no_response = "no_response",
  other_manufacturing_partner = "other_manufacturing_partner",
  responsibility_unclear = "responsibility_unclear",
}

/**
 * MP level job request sort type for snapshot details
 */
export enum MfgPartnerLevelJobRequestSortType {
  JOB_ACCEPTED_AT_ASC = "JOB_ACCEPTED_AT_ASC",
  JOB_ACCEPTED_AT_DESC = "JOB_ACCEPTED_AT_DESC",
  JOB_COMPLETED_AT_ASC = "JOB_COMPLETED_AT_ASC",
  JOB_COMPLETED_AT_DESC = "JOB_COMPLETED_AT_DESC",
  JOB_EXPIRED_AT_ASC = "JOB_EXPIRED_AT_ASC",
  JOB_EXPIRED_AT_DESC = "JOB_EXPIRED_AT_DESC",
  JOB_REJECTED_AT_ASC = "JOB_REJECTED_AT_ASC",
  JOB_REJECTED_AT_DESC = "JOB_REJECTED_AT_DESC",
}

/**
 * Enum for MP level
 */
export enum MfgPartnerLevelType {
  bronze = "bronze",
  gold = "gold",
  silver = "silver",
  suspended = "suspended",
}

/**
 * Enum for allowed manufacturing partner sort options
 */
export enum MfgPartnerSortInput {
  MFG_PARTNER_NAME_ASC = "MFG_PARTNER_NAME_ASC",
  MFG_PARTNER_NAME_DESC = "MFG_PARTNER_NAME_DESC",
}

/**
 * Enum for sales order type
 */
export enum OrderType {
  high_touch = "high_touch",
  self_serve = "self_serve",
}

/**
 * Used to determine what kind of point we have
 */
export enum P2PPointType {
  custom = "custom",
  geometry = "geometry",
}

/**
 * ProcessInspectionCriteria
 */
export enum ProcessInspectionCriteria {
  all_dimensions = "all_dimensions",
  bubbled_dimensions = "bubbled_dimensions",
}

/**
 * Enum for salesorder line production country
 */
export enum ProductionCountry {
  CN = "CN",
  IN = "IN",
  MX = "MX",
  US = "US",
}

/**
 * Enum for salesorder line production country filter options
 */
export enum ProductionCountryFilter {
  CN = "CN",
  IN = "IN",
  MX = "MX",
  US = "US",
  Unassigned = "Unassigned",
}

/**
 * Flags for a quote model revision
 */
export enum QmrFlag {
  not_reorderable = "not_reorderable",
}

/**
 * Quote attributes that can be used to filter quote results
 */
export enum QuoteAttributeFilterType {
  SECURE_PLUS = "SECURE_PLUS",
}

/**
 * Types for quote level lead times region
 */
export enum QuoteLevelLeadTimesRegion {
  DOMESTIC = "DOMESTIC",
  OVERSEAS = "OVERSEAS",
}

/**
 * States for a quote model revision to be in
 */
export enum QuoteModelRevisionState {
  deleted = "deleted",
  error = "error",
  needs_configuration = "needs_configuration",
  needs_rfq = "needs_rfq",
  not_manufacturable = "not_manufacturable",
  processing = "processing",
  purchasable = "purchasable",
  registered = "registered",
  unresolved_dfm = "unresolved_dfm",
}

/**
 * Types for quote
 */
export enum QuoteType {
  generic = "generic",
  im = "im",
}

/**
 * Enum for calculation record type
 */
export enum RecordType {
  active = "active",
  weekly = "weekly",
}

/**
 * production and inspection status
 */
export enum ReportState {
  completed = "completed",
  in_progress = "in_progress",
  pending = "pending",
}

/**
 * Possible Risk statuses for a job request
 */
export enum RiskStatus {
  at_risk = "at_risk",
  completed = "completed",
  not_available = "not_available",
  not_started = "not_started",
  on_track = "on_track",
}

/**
 * Enum for the allowed dfm annotation types
 */
export enum RoleSourceType {
  BUSINESS_ACCOUNT = "BUSINESS_ACCOUNT",
  INDIVIDUAL = "INDIVIDUAL",
}

/**
 * Enum for user.salesForceAccountIdState
 */
export enum SalesForceAccountIdStateEnum {
  COMPANY_ACCOUNT = "COMPANY_ACCOUNT",
  MASTER_GENERIC = "MASTER_GENERIC",
  PENDING_SYNC = "PENDING_SYNC",
}

/**
 * Sales order priority
 */
export enum SalesOrderPriority {
  normal = "normal",
  not_urgent = "not_urgent",
  urgent = "urgent",
  very_urgent = "very_urgent",
}

/**
 * Types for stages
 */
export enum StageType {
  bridge_production = "bridge_production",
  design_validation = "design_validation",
  production = "production",
}

/**
 * Enum for sorting quotes and orders in Teams query
 */
export enum TeamQuotesAndOrdersSortInput {
  CREATED_AT_ASC = "CREATED_AT_ASC",
  CREATED_AT_DESC = "CREATED_AT_DESC",
}

/**
 * Additional input for IM to accept an optional param specifying whether a user needs ‘fictiv guidance’:
 */
export interface AdditionalConfigInput {
  userNeedsConfigHelp?: boolean | null;
}

/**
 * Input fields for an address
 */
export interface AddressInput {
  name: string;
  address1: string;
  address2?: string | null;
  city: string;
  state: string;
  zip: string;
  phone: string;
  firstName: string;
  company?: string | null;
  country?: string | null;
}

/**
 * Input for admin quoted advanced inspection - admin parameters
 */
export interface AdminInspectionPricingParamsInput {
  numInspectionPoints: number;
  numSpecialInspectionPoints: number;
  percentMarkup: number;
}

/**
 * Input for filtering list of admin job requests
 */
export interface AdminJobRequestFiltersInput {
  fromDate?: any | null;
  toDate?: any | null;
  salesOrderNameLike?: string | null;
  jobRequestNameLike?: string | null;
  mfgDriUserId?: (number | null)[] | null;
  priority?: (SalesOrderPriority | null)[] | null;
  processTypeIds?: (number | null)[] | null;
  jobRequestStatus?: (string | null)[] | null;
  riskState?: JobRequestRiskState | null;
  payout?: PayoutFilterInput | null;
  countryIds?: (number | null)[] | null;
  mpNameLike?: string | null;
  projectNameLike?: string | null;
  jobRequestState?: (string | null)[] | null;
  earliestScheduledDeliveryDateStart?: string | null;
  earliestScheduledDeliveryDateEnd?: string | null;
  earliestReceiptDateStart?: string | null;
  earliestReceiptDateEnd?: string | null;
  requestDateStart?: string | null;
  requestDateEnd?: string | null;
  mfgPartnerIds?: (number | null)[] | null;
  inspectionStatus?: (JobRequestInspectionStatus | null)[] | null;
  businessUnits?: string[] | null;
}

/**
 * Input for advanced inspection in the admin quoting page
 */
export interface AdvancedInspectionDataInput {
  numInspectionPoints: number;
  numSpecialInspectionPoints: number;
  percentMarkup: number;
  notes?: string | null;
  domesticLeadTimeDays?: number | null;
  overseasLeadTimeDays?: number | null;
  mpCost?: number | null;
}

/**
 * Input for creating an attachment
 */
export interface AttachmentInput {
  fileName: string;
  extension?: string | null;
  mimeType?: string | null;
  type?: AttachmentCreateType | null;
}

/**
 * Input for business account discount
 */
export interface BusinessAccountDiscountDataInput {
  salesforceOpportunityId: string;
  salesforceOpportunityName: string;
  percent: number;
  startDate: any;
  endDate: any;
  notes?: string | null;
}

/**
 * Input for BusinessAccountMembersQuery
 */
export interface BusinessAccountMembersFilterInput {
  businessAccountId?: string | null;
  searchText?: string | null;
  membershipStatus?: BusinessAccountMembershipStatus | null;
  membershipStatuses?: BusinessAccountMembershipStatus[] | null;
}

/**
 * Input for businessAccountPendingMembersQuery
 */
export interface BusinessAccountPendingMembersFilterInput {
  businessAccountId?: string | null;
  searchText?: string | null;
  inviteStatus?: BusinessAccountInviteStatus | null;
  inviteStatuses?: BusinessAccountInviteStatus[] | null;
}

/**
 * Type corresponding to all the flags given as input in quote change request
 */
export interface ChangeFlagsInput {
  designChange: boolean;
  quantityChange: boolean;
  configurationChange: boolean;
  otherChange: boolean;
}

/**
 * Input for quote change request
 */
export interface ChangeRequestInput {
  changeTypes: ChangeFlagsInput;
  changeDescription: string;
}

/**
 * Input for class a values
 */
export interface ClassATypeInput {
  required?: boolean | null;
  partComplexity?: string | null;
  productionCostsInCents?: DomesticAndOverseasCostDataInput | null;
  nonRecurringCostsInCents?: DomesticAndOverseasCostDataInput | null;
}

/**
 * Pricing overrides specific to cnc
 */
export interface CncPricingConstantOverridesInput {
  shopRateCentsPerHour: number;
  operatorRateCentsPerHour: number;
  useOverseas: boolean;
}

/**
 * Input for ModelConfiguration
 */
export interface ConfigInput {
  processId?: string | null;
  materialId?: string | null;
  colorId?: string | null;
  shoreId?: string | null;
  textureId?: string | null;
  postProcessId?: string | null;
  postProcessColorId?: string | null;
  postProcessThickness?: number | null;
  priorityId?: string | null;
  quantity: number;
}

/**
 * Corrective action request attachment input type
 */
export interface CorrectiveActionRequestAttachmentInput {
  correctiveActionRequestId: any;
  attachment: AttachmentInput;
}

/**
 * Input for corrective action request filters
 */
export interface CorrectiveActionRequestFilterInput {
  correctiveActionRequestNameLike?: string | null;
  jobRequestNameLike?: string | null;
  salesOrderNameLike?: string | null;
  mfgPartnerNameLike?: string | null;
  exceptionNameLike?: string | null;
  correctiveActionRequestStatuses?: CorrectiveActionRequestStatus[] | null;
  exceptionStatuses?: ExceptionStates[] | null;
  failureTypes?: CorrectiveActionRequestFailureType[] | null;
  assignees?: (number | null)[] | null;
  mfgPartners?: (number | null)[] | null;
  supplierQualityEngineerIds?: number[] | null;
  createdAtStartDate?: string | null;
  createdAtEndDate?: string | null;
  sentAtStartDate?: string | null;
  sentAtEndDate?: string | null;
  viewedAtStartDate?: string | null;
  viewedAtEndDate?: string | null;
  dueAtStartDate?: string | null;
  dueAtEndDate?: string | null;
  submittedAtStartDate?: string | null;
  submittedAtEndDate?: string | null;
  canceledAtStartDate?: string | null;
  canceledAtEndDate?: string | null;
  sentForReworkAtStartDate?: string | null;
  sentForReworkAtEndDate?: string | null;
}

/**
 * DFM annotations.
 * TODO: Change the usage of this back to QmrAttachmentAnnotationsInput
 * when frontend is updated to use the new style of annotations
 */
export interface DfmAttachmentAnnotationsInput {
  data: string;
  userId?: number | null;
}

/**
 * dfm and modelviewer snapshot input for createDfmFeedbackWithSnapshot
 */
export interface DfmFeedbackWithSnapshotInput {
  severity?: string | null;
  message: string;
  topicId: any;
  title?: string | null;
  status?: string | null;
  link?: string | null;
  code?: string | null;
  snapshotInfo: ViewerSnapshotInput;
}

/**
 * Input for domestic and overseas costs
 */
export interface DomesticAndOverseasCostDataInput {
  usa?: number | null;
  china?: number | null;
  india?: number | null;
}

/**
 * Input for domestic and overseas manufacturability
 */
export interface DomesticAndOverseasManufacturabilityDataInput {
  usa?: boolean | null;
  china?: boolean | null;
  india?: boolean | null;
}

/**
 * Input for domestic and overseas costs
 */
export interface DomesticAndOverseasMaterialStockDataInput {
  usa?: any | null;
  china?: any | null;
  india?: any | null;
}

/**
 * Input for DfmInspection for each regions quoted fixturing methods
 */
export interface DomesticAndOverseasQuotedFixturingMethodsInput {
  usa?: QuotedFixturingMethodsInput | null;
  china?: QuotedFixturingMethodsInput | null;
  india?: QuotedFixturingMethodsInput | null;
}

/**
 * Input used for edm calculator pricing options
 */
export interface EdmCalculatorInput {
  stepItems: StepItemInput[];
}

/**
 * Input used for  edm calculator pricing options
 */
export interface EdmSinkerKnownRemovalVolumeItemInput {
  roughness: string;
  setups: number;
  volumeRemoved: number;
}

/**
 * Input used for  edm calculator pricing options
 */
export interface EdmSinkerNoKnownRemovalVolumeItemInput {
  roughness: string;
  setups: number;
  desiredFilletRadius: number;
  standardFilletRadius: number;
  lengthOfFillet: number;
}

/**
 * Input used for  edm calculator pricing options
 */
export interface EdmWireItemInput {
  gear: string;
  roughness: string;
  cutPath: number;
  plateThickness: number;
}

/**
 * Input for filtering list of Work Order Requests
 */
export interface ExceptionsFilterInput {
  exceptionNameLike?: string | null;
  salesOrderNameLike?: string | null;
  workOrderNameLike?: string | null;
  mpNameLike?: string | null;
  status?: (string | null)[] | null;
  type?: (string | null)[] | null;
  assignee?: (ExceptionAssignee | null)[] | null;
  action?: (string | null)[] | null;
  ontimeFailure?: (string | null)[] | null;
  inFullFailure?: (string | null)[] | null;
  earliestPromisedShipDateStart?: string | null;
  earliestPromisedShipDateEnd?: string | null;
  earliestScheduledDeliveryDateStart?: string | null;
  earliestScheduledDeliveryDateEnd?: string | null;
  earliestReceiptDateStart?: string | null;
  earliestReceiptDateEnd?: string | null;
  workOrderRequestDateStart?: string | null;
  workOrderRequestDateEnd?: string | null;
  correctiveActionRequestNameLike?: string | null;
  correctiveActionRequestStatuses?: CorrectiveActionRequestStatus[] | null;
  correctiveActionRequestTypes?: CorrectiveActionRequestType[] | null;
  failuresType?: FailureTypes[] | null;
  createdBy?: (number | null)[] | null;
  partnerId?: number | null;
  mfgDriUserIds?: (number | null)[] | null;
}

/**
 * FeatureFlagInput
 */
export interface FeatureFlagInput {
  key: string;
  rules: FeatureFlagRuleInput[];
  defaultVariant: string;
  scope: FeatureFlagScope;
}

/**
 * FeatureFlagRuleInput
 */
export interface FeatureFlagRuleInput {
  attribute: string;
  operation: string;
  values: string[];
  variant: string;
}

/**
 * input Follower user details
 */
export interface FollowerUserDetailsInput {
  id: number;
  name: string;
}

/**
 * Input used for upserting the calculated hardware installation secondary process
 */
export interface HardwareInstallationConfigInput {
  domesticProductionConfigInput?: ManuallyQuotedSecondaryProcessRegionalInput | null;
  internationalProductionConfigInput?: ManuallyQuotedSecondaryProcessRegionalInput | null;
  notes?: string | null;
  lineItems: HardwareLineItemInput[];
}

/**
 * Input used for calculating pending hardware installation prices
 */
export interface HardwareInstallationPricingInput {
  domesticProductionConfigInput?: PartialManuallyQuotedSecondaryProcessRegionalInput | null;
  internationalProductionConfigInput?: PartialManuallyQuotedSecondaryProcessRegionalInput | null;
  lineItems: HardwareLineItemInput[];
}

/**
 * Input used for hardware installation pricing options
 */
export interface HardwareLineItemInput {
  supplier?: string | null;
  partNumber?: string | null;
  qtyPerPart: number;
  pricePerPack: number;
  qtyPerPack: number;
}

/**
 * Input type for updateHts mutation
 */
export interface HtsUpdateInput {
  salesOrderLineId: string;
  htsCode?: string | null;
  description?: string | null;
  application?: string | null;
  usageType?: string | null;
  htsSubmitted?: boolean | null;
}

/**
 * Input for IM part dimensions
 */
export interface InjectionMoldingDimensionsInput {
  length?: number | null;
  width?: number | null;
  depth?: number | null;
}

/**
 * Input for DfmInspection im parameters
 */
export interface InjectionMoldingParametersInput {
  volume?: number | null;
  pricingMaterial?: string | null;
  pricingColor?: string | null;
  pricingFinish?: string | null;
  pricingDimensions?: InjectionMoldingDimensionsInput | null;
  partProductionDays?: number | null;
  wallThicknessMean?: number | null;
  positiveZSliderQty?: number | null;
  negativeZSliderQty?: number | null;
  negativeWidthSliderQty?: number | null;
  positiveWidthSliderQty?: number | null;
  negativeLengthSliderQty?: number | null;
  positiveLengthSliderQty?: number | null;
  pricingMaterialDifficultyFactor?: number | null;
  pricingMaterialCost?: number | null;
  pricingMaterialDensity?: number | null;
}

/**
 * Input for InspectionData
 *   miscNonRecurringEngineeringCostInCents ==> scrapMaterial + additionalNreInCents (OLD USE)
 *       - new use no longer rolls up other costs into miscNRE
 *   miscProductionCostInCents ==> threadCostsInCents + otherProductionCostsInCents
 */
export interface InspectionDataInput {
  miscNonRecurringEngineeringCostInCents: number;
  miscProductionCostInCents: number;
  numThreadedFeatures?: number | null;
  threadCostsInCents?: number | null;
  otherProductionCostsInCents?: number | null;
  camSeconds?: number | null;
  machiningSeconds?: number | null;
  numSetups?: number | null;
  numNonStandardFixtures?: number | null;
  machineTimeMultiplier: number;
  dfmTags: DfmTags[];
  minInsideRadius?: number | null;
  threadsDescription?: string | null;
  additionalNreInCents?: number | null;
  allowedPriorityIds?: string[] | null;
  baseProductionDayOverridesByPriorityId?: LeadTimeOverridesInput | null;
  notes?: string | null;
  supportingDocAnalysis?: any | null;
  markupData?: PendingMarkupDataInput | null;
  advancedInspectionData?: AdvancedInspectionDataInput | null;
  scrapRateData?: ScrapRateDataInput | null;
  imParameters?: InjectionMoldingParametersInput | null;
  deepHoleNonRecurringEngineeringCost?: number | null;
  deepHoleProductionCosts?: number | null;
  edmNonRecurringEngineeringCost?: number | null;
  edmStepItems?: StepItemInput[] | null;
  hobbingNonRecurringEngineeringCost?: number | null;
  hobbingProductionCosts?: number | null;
  numTightTolerances?: number | null;
  numVeryTightTolerances?: number | null;
  complexityCategory?: string | null;
  tabbingMachiningSeconds?: number | null;
  specialFixturingParameters?: SpecialFixturingParametersInput | null;
  classA?: ClassATypeInput | null;
  toolCostsInCents?: DomesticAndOverseasCostDataInput | null;
  materialCostsInCents?: DomesticAndOverseasCostDataInput | null;
  scrapMaterialCostsInCents?: DomesticAndOverseasCostDataInput | null;
  edmProductionCostsInCents?: DomesticAndOverseasCostDataInput | null;
  reamerCostsInCents?: DomesticAndOverseasCostDataInput | null;
  tapToolCostsInCents?: DomesticAndOverseasCostDataInput | null;
  undercuttingToolCostsInCents?: DomesticAndOverseasCostDataInput | null;
  materialStocks?: DomesticAndOverseasMaterialStockDataInput | null;
  allowedInRegion?: DomesticAndOverseasManufacturabilityDataInput | null;
  toolCosts?: number | null;
  overseasToolCosts?: number | null;
  materialCostInCents?: number | null;
  overseasMaterialCostInCents?: number | null;
  materialStock?: any | null;
  overseasMaterialStock?: any | null;
  scrapMaterial?: number | null;
  domesticScrapMaterial?: number | null;
  overseasScrapMaterial?: number | null;
  domesticReamerCosts?: number | null;
  domesticTapToolCosts?: number | null;
  domesticUndercuttingCosts?: number | null;
  edmProductionCosts?: number | null;
  overseasEdmProductionCosts?: number | null;
  overseasReamerCosts?: number | null;
  overseasTapToolCosts?: number | null;
  overseasUndercuttingCosts?: number | null;
}

/**
 * Input fields for a creating a JobRequestComment
 */
export interface JobRequestCommentInput {
  id: string;
  body: string;
  subject?: AllowedSubjectTypes | null;
  partName?: string | null;
  attachmentIds?: number[] | null;
}

/**
 * Input to create a new JobRequestAttachment for multiple parts
 */
export interface JobRequestLineAttachmentInput {
  jobRequestId: string;
  attachment: AttachmentInput;
  type?: AllowedQualityAttachmentTypes | null;
  jobRequestLineIds: number[];
  source: AllowedAttachmentSources;
}

/**
 * Input for lead time overrides in admin quoting page
 */
export interface LeadTimeOverridesInput {
  rush?: number | null;
  standard?: number | null;
  economy?: number | null;
  flex?: number | null;
  saver?: number | null;
  overseas?: number | null;
}

/**
 * Input for lifters
 */
export interface LifterInput {
  length?: number | null;
  width?: number | null;
}

/**
 * Regionally differentiated input for manually/admin quoted secondary mfg production process (i.e. processes not yet auto-quotable)
 */
export interface ManuallyQuotedSecondaryProcessRegionalInput {
  percentMarkup: number;
  mpPayoutInCents: number;
  mpPayoutPartsLimit: number;
  leadTime: number;
  leadTimePartsLimit: number;
}

/**
 * Input needed to adjust platform markups
 */
export interface MarkupDataInput {
  markups: MarkupsByPriorityInput;
  quantityRanges: number[];
}

/**
 * Mapping of priority to markups at different quantity ranges input.
 */
export interface MarkupsByPriorityInput {
  premium: number[];
  rush: number[];
  standard: number[];
  economy: number[];
  flex: number[];
  saver: number[];
  overseas: number[];
}

/**
 * MP level job request filter input type for snapshot details
 */
export interface MfgPartnerLevelJobRequestFilterInput {
  priority?: SalesOrderPriority[] | null;
  jobRequestNameLike?: string | null;
  saleOrderNameLike?: string | null;
  jobRequestStatuses?: JobRequestStatus[] | null;
  jobAcceptedDateStart?: any | null;
  jobAcceptedDateEnd?: any | null;
  jobExpiredDateStart?: any | null;
  jobExpiredDateEnd?: any | null;
  jobCompletedDateStart?: any | null;
  jobCompletedDateEnd?: any | null;
  jobRejectedDateStart?: any | null;
  jobRejectedDateEnd?: any | null;
}

/**
 * MP level input type for job requests
 */
export interface MfgPartnerLevelJobRequestInput {
  filters?: MfgPartnerLevelJobRequestFilterInput | null;
  sort?: MfgPartnerLevelJobRequestSortType | null;
  limit?: number | null;
  offset?: number | null;
}

/**
 * MfgPartnerLevels Filters Type
 */
export interface MfgPartnerLevelsFiltersInput {
  fromDate?: any | null;
  toDate?: any | null;
  mpLevels?: MfgPartnerLevelType[] | null;
}

/**
 * Input fields for a model attachment annotation record.
 */
export interface ModelAttachmentAnnotationInput {
  estimateItemUUID?: any | null;
  attachmentId?: any | null;
  documentPage: number;
  positionX: number;
  positionY: number;
  radius: number;
}

/**
 * Input fields for creating a model attachment callout
 */
export interface ModelAttachmentCalloutInput {
  modelAttachmentAnnotationInput: ModelAttachmentAnnotationInput;
  modelAttachmentSelectionInput: ModelAttachmentSelectionInput;
}

/**
 * Input fields for a model attachment selection record.
 */
export interface ModelAttachmentSelectionInput {
  estimateItemUUID?: any | null;
  attachmentId?: any | null;
  documentPage: number;
  positionX: number;
  positionY: number;
  userAnnotationsId?: any | null;
  width?: number | null;
  height?: number | null;
  text?: string | null;
}

/**
 * Configuration for model viewer part annotation visualization
 */
export interface ModelViewerAnnotationConfigInput {
  position: number[];
}

/**
 * Configuration for model viewer camera
 */
export interface ModelViewerCameraConfigInput {
  position: number[];
  up?: number[] | null;
  target?: number[] | null;
  zoom: number;
}

/**
 * Configuration for model viewer
 */
export interface ModelViewerConfigInput {
  camera?: ModelViewerCameraConfigInput | null;
  part: ModelViewerPartConfigInput;
  rotation?: number[] | null;
  annotations: ModelViewerAnnotationConfigInput[];
  dfm: ModelViewerDfmFeatureConfigInput[];
  crossSection?: ModelViewerCrossSectionConfigInput | null;
  pointToPoint?: PointToPointConfigInput | null;
}

/**
 * Input ofr the state of the cross section tools in the 3D Viewer
 */
export interface ModelViewerCrossSectionConfigInput {
  position: any;
  rotation: any;
}

/**
 * Configuration for model viewer dfm feature visualization
 */
export interface ModelViewerDfmFeatureConfigInput {
  color?: string | null;
  threshold?: number | null;
  feature: string;
  direction?: number[] | null;
}

/**
 * Configuration for model viewer part visualization
 */
export interface ModelViewerPartConfigInput {
  transparent: boolean;
  patches: ModelViewerPatchConfigInput[];
}

/**
 * Configuration for model viewer part patch visualization
 */
export interface ModelViewerPatchConfigInput {
  color?: string | null;
  hashcode: string;
}

/**
 * Input for create ModelViewerSnapshot
 */
export interface ModelViewerSnapshotInput {
  quoteModelRevisionId: any;
  position: any;
  target: any;
  feature?: string | null;
  type: string;
  snapshot: ModelViewerConfigInput;
}

/**
 * Input for mold inspection data
 */
export interface MoldToolInspectionDataInput {
  toolLife?: number | null;
  cavitySharedWithMoldBase?: boolean | null;
  coreSharedWithMoldBase?: boolean | null;
  cavityMaterial?: string | null;
  coreMaterial?: string | null;
  customerProvidingMaterial?: boolean | null;
  surfaceFinish?: string | null;
  precisionGrade?: string | null;
  partingLine?: string | null;
  gateType?: string | null;
  ejectionType?: string | null;
  warpType?: string | null;
  specialFeatures?: string[] | null;
  manualInsertsQty?: number | null;
  manualThreadInsertQty?: number | null;
  automaticThreadInsertQty?: number | null;
  sliders?: SliderInput[] | null;
  lifters?: LifterInput[] | null;
  leadTimeDaysOverride?: number | null;
  partMarkupPercent?: number | null;
  toolMarkupPercent?: number | null;
  usdToYuanExchangeRateOverride?: number | null;
  additionalCostCents?: number | null;
  notes?: string | null;
  slidersCount?: number | null;
  liftersCount?: number | null;
  cavityCounts?: number[] | null;
}

/**
 * Input for mold override data
 */
export interface MoldToolOverrideInput {
  manualOverrideMpUnitPayout: number;
  manualOverrideUnitAmount: number;
}

/**
 * Input for mold tool revision
 */
export interface MoldToolRevisionInput {
  toolLife?: number | null;
  cavityMaterial?: string | null;
  coreMaterial?: string | null;
  gateType?: string | null;
  slidersCount?: number | null;
  liftersCount?: number | null;
  leadTimeDaysOverride?: number | null;
  cavityCounts?: number[] | null;
  cavitySharedWithMoldBase?: boolean | null;
  coreSharedWithMoldBase?: boolean | null;
  precisionGrade?: string | null;
  partingLine?: string | null;
  ejectionType?: string | null;
  warpType?: string | null;
  specialFeatures?: string[] | null;
  manualInsertsQty?: number | null;
  manualThreadInsertQty?: number | null;
  automaticThreadInsertQty?: number | null;
  sliders?: SliderInput[] | null;
  lifters?: LifterInput[] | null;
  partMarkupPercent?: number | null;
  toolMarkupPercent?: number | null;
  usdToYuanExchangeRateOverride?: number | null;
  additionalCostCents?: number | null;
}

/**
 * Input for DfmInspection nesting parameters
 */
export interface NestingParametersInput {
  minimumNumberOfNestedParts?: number | null;
  nestingMaterialStocks?: DomesticAndOverseasMaterialStockDataInput | null;
  domesticNestingMaterialStock?: any | null;
  overseasNestingMaterialStock?: any | null;
}

/**
 * Input for part pricing and lead time
 */
export interface OverridePartPricingLeadtimeInput {
  manualOverrideMpUnitPayout: number;
  manualOverrideUnitAmount: number;
  manualOverrideUnitProductionDays: number;
}

/**
 * Input for point to point measurement point
 */
export interface P2PPointInput {
  index: number;
  type: P2PPointType;
}

/**
 * Input for part inspection data
 */
export interface PartInspectionDataInput {
  inspectionData: InjectionMoldingParametersInput;
  qmrId: string;
}

/**
 * Input for admin quoted advanced inspection - setup based parameters
 */
export interface PartSetupsInspectionPricingParamsInput {
  numSetups: number;
  numSpecialFixtures: number;
}

/**
 * Used for the hardware installation process regional input. These are optional since the pricing and lead time
 * calculator can handle these on its own. If these are passed in, they override the calculator.
 */
export interface PartialManuallyQuotedSecondaryProcessRegionalInput {
  percentMarkup?: number | null;
  mpPayoutInCents?: number | null;
  mpPayoutPartsLimit?: number | null;
  leadTime?: number | null;
  leadTimePartsLimit?: number | null;
}

/**
 * Input provided to filter work order by payout
 */
export interface PayoutFilterInput {
  to: number;
  from: number;
}

/**
 * Input for markup overrides in admin quoting page
 */
export interface PendingMarkupDataInput {
  rush?: number | null;
  standard?: number | null;
  economy?: number | null;
  flex?: number | null;
  saver?: number | null;
  overseas?: number | null;
}

/**
 * Input config for point to point measurement DFM
 */
export interface PointToPointConfigInput {
  customPoints: any[];
  selectedPoints: P2PPointInput[];
}

/**
 * Constant overrides for various pricing algorithms.
 */
export interface PricingConstantOverridesInput {
  cnc?: CncPricingConstantOverridesInput | null;
}

/**
 * Input for primary mfg production process (cnc, im, 3dp, i.e. processes that manufacture the model)
 */
export interface PrimaryProcessConfigInput {
  processId?: string | null;
  materialId?: string | null;
  colorId?: string | null;
  shoreId?: string | null;
  textureId?: string | null;
  priorityId?: string | null;
  quantity?: number | null;
  materialGrade?: string | null;
  colorCode?: string | null;
  textureCode?: string | null;
  fdmInfillPercentageCategory?: string | null;
}

/**
 * Input fields for a Project record
 */
export interface ProjectInput {
  name: string;
  description: string;
  userEmails: string[];
  isSecurePlus: boolean;
}

/**
 * Input fields for to update a Project record (empty fields will not have their values updated)
 */
export interface ProjectUpdateInput {
  name?: string | null;
  description?: string | null;
  userEmails?: string[] | null;
  isSecurePlus?: boolean | null;
}

/**
 * Input field for Annotations
 */
export interface QmrAttachmentAnnotationsInput {
  sanitizationInfo?: SanitizationInfoInput | null;
  annotationsDataId: any;
  userId?: number | null;
}

/**
 * QuantityRange values
 */
export interface QuantityRangeInput {
  quantityLowerRange: number;
  quantityUpperRange: number;
  isQuantityRangeAvailable: boolean;
}

/**
 * Input fields for a quote record.
 */
export interface QuoteInput {
  name?: string | null;
  description?: string | null;
  zipCode?: string | null;
  isMoldRepair?: boolean | null;
  rfqNotes?: string | null;
}

/**
 * Input for uploading a new quote model QuoteModelRevision
 */
export interface QuoteModelRevisionUploadInput {
  contentType: string;
  fileName: string;
  fileSize: number;
  referenceId: any;
  units?: string | null;
}

/**
 * Input fields for customization of emails on Quote release
 */
export interface QuoteReadyEmailInput {
  emailFrom: string;
  emailTo: string;
  emailsCC?: (string | null)[] | null;
  emailSubject: string;
  emailNotes?: string | null;
}

/**
 * Input for DfmInspection quoted fixturing method
 */
export interface QuotedFixturingMethodsInput {
  mill?: string | null;
}

/**
 * Input field for Rawbox
 */
export interface RawBoxInput {
  boundingBox?: SanitizationBoundingBoxInput | null;
  isFictiv?: boolean | null;
  trnAnnotNoMove?: boolean | null;
  userName?: string | null;
}

/**
 * Input for reprocess parameters
 */
export interface ReprocessParametersInput {
  reprocess?: boolean | null;
  imPullDirectionOverride?: number[] | null;
}

/**
 * Input for filtering list of SalesOrders
 */
export interface SalesOrdersFiltersInput {
  salesOrderNameLike?: string | null;
  workOrderNameLike?: string | null;
  projectNameLike?: string | null;
  priority?: (SalesOrderPriority | null)[] | null;
  workOrderStatus?: (string | null)[] | null;
  earliestPromisedShipDateStart?: string | null;
  earliestPromisedShipDateEnd?: string | null;
  earliestScheduledDeliveryDateStart?: string | null;
  earliestScheduledDeliveryDateEnd?: string | null;
  committedDeliveryDateStart?: string | null;
  committedDeliveryDateEnd?: string | null;
  mfgDriUserId?: (number | null)[] | null;
  region?: (string | null)[] | null;
  productionCountry?: ProductionCountryFilter[] | null;
  schedulingDriUserIds?: (number | null)[] | null;
  businessUnits?: string[] | null;
}

/**
 * Input field for Sanitizationboundingbox
 */
export interface SanitizationBoundingBoxInput {
  xmax?: number | null;
  xmin?: number | null;
  ymax?: number | null;
  ymin?: number | null;
}

/**
 * Input field for Sanitizationinfo
 */
export interface SanitizationInfoInput {
  numAutoRedBoxes?: number | null;
  numAdminRedBoxes?: number | null;
  rawBoxInfo?: (RawBoxInput | null)[] | null;
}

/**
 * Input for scrap rate in the admin quoting page
 */
export interface ScrapRateDataInput {
  numParts: number;
  numPartsBase: number;
}

/**
 * Input for secondary mfg production process (anodizing, media-blasting, i.e. processes that change the quality of the manufactured model)
 */
export interface SecondaryProcessConfigInput {
  processId: string;
  processColorId?: string | null;
  processThicknessInInches?: number | null;
  processNumParts?: number | null;
  processInspectionCriteria?: ProcessInspectionCriteria | null;
}

/**
 * Input for sliders
 */
export interface SliderInput {
  length?: number | null;
  width?: number | null;
  depth?: number | null;
}

/**
 * Input for DfmInspection special fixturing parameters
 */
export interface SpecialFixturingParametersInput {
  canBeTabbed?: boolean | null;
  tabbingParameters?: TabbingParametersInput | null;
  canBeNested?: boolean | null;
  nestingParameters?: NestingParametersInput | null;
  quotedFixturingMethods?: DomesticAndOverseasQuotedFixturingMethodsInput | null;
}

/**
 * Input used for  edm calculator pricing options
 */
export interface StepItemInput {
  wire?: EdmWireItemInput | null;
  sinkerKnownRemoval?: EdmSinkerKnownRemovalVolumeItemInput | null;
  sinkerNoKnownRemoval?: EdmSinkerNoKnownRemovalVolumeItemInput | null;
}

/**
 * Input for DfmInspection tabbing parameters
 */
export interface TabbingParametersInput {
  tabbingMachiningSeconds?: number | null;
  tabbingCamSeconds?: number | null;
  tabbingSpecialFixtures?: number | null;
  maximumNumberOfTabbedParts?: number | null;
  tabbingMaterialStocks?: DomesticAndOverseasMaterialStockDataInput | null;
  domesticTabbingMaterialStock?: any | null;
  overseasTabbingMaterialStock?: any | null;
}

/**
 * Input for quoteTeamMemberships and orderTeamMemberships query
 */
export interface TeamQuoteAndOrderFilterInput {
  searchText?: string | null;
}

/**
 * Input for Teams query
 */
export interface TeamsFilterInput {
  userId?: number | null;
  businessAccountId?: any | null;
}

/**
 * input for Update Job Request Follower
 */
export interface UpdateJobRequestFollowersInput {
  addFollowers?: FollowerUserDetailsInput[] | null;
  removeFollowers?: FollowerUserDetailsInput[] | null;
}

/**
 * Input for MTR to QMR association update
 */
export interface UpdateQmrAssociationInput {
  quoteModelRevisionId: any;
  cavityPerPart: number;
}

/**
 * model viewer snapshot input for createDfmFeedbackWithSnapshot
 */
export interface ViewerSnapshotInput {
  position: any;
  target: any;
  feature?: string | null;
  type: string;
  snapshot: ModelViewerConfigInput;
  assetId: any;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
